import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d1292d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Recurring Billing", -1))
const _hoisted_4 = { class: "larger-width-centered" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Autopay", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Card Info", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Billing Day", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Next Autopay Date", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Activate ")
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Activate ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Deactivate")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Autopay")

import { ref } from "vue";
import BaseSpinner from "@/components/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert.vue";

import api from "@virgodev/bazaar/functions/api";
import { storeToRefs } from "pinia";
import { useStore } from "../../store";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: [Number, String],
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const providerName = (userData.value.chosenFacility.api_name || "").replace(
  /_/g,
  " "
);
const status = ref("loading");

const errors = ref("");
const customer = ref();
const rentals = ref();
const paymentAccounts = ref();

async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body[0];

    await getLedgers();
    await getPaymentAccounts();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  status.value = "loaded";
}
async function getLedgers() {
  errors.value = "";
  let response;
  if (!api_settings.use_contact_id) {
    if (
      customer.value.current_ledger_ids &&
      !api_settings.customer_id_with_ledgers
    ) {
      response = await api({
        url: `ledgers/?only_ids=${customer.value.current_ledger_ids.join(
          ","
        )}&include_as_object=events&facilityId=${props.facilityId}`,
      });
    } else {
      response = await api({
        url: `ledgers/?id=${props.customerId}&facilityId=${props.facilityId}`,
      });
    }
    if (response.status == 200) {
      if (response.body.ledgers) {
        rentals.value = response.body.ledgers;
      } else {
        rentals.value = response.body;
      }
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
  } else {
    rentals.value = customer.value.rentals;
    customer.value.current_ledger_ids = [];
    for (let rental of rentals.value) {
      customer.value.current_ledger_ids.push(rental.id);
    }
  }
}
async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (
      !api_settings.filter_payment_accounts &&
      !api_settings.use_autopay_in_rental
    ) {
      paymentAccounts.value = response.body;
    } else {
      paymentAccounts.value = response.body;
      if (rentals.value.length) {
        for (let rental of rentals.value) {
          let account_id = rental.id;
          if (api_settings.use_autopay_in_rental && rental.autopay) {
            account_id = rental.autopay;
          }
          let info = paymentAccounts.value.filter(
            (item: { id: number }) => item.id == account_id
          )[0];
          rental.autopay_info = {};
          if (
            (info && info.autopay) ||
            (api_settings.use_autopay_in_rental && rental.autopay)
          ) {
            rental.autopay_enabled = true;
            rental.autopay_info = info;
          } else {
            rental.autopay_enabled = false;
          }
          if (info) {
            rental.full_data = info.full_data;
          }
        }
      }
      paymentAccounts.value = response.body;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function deactivateAutopay(data: {
  dCredtiCardExpir: string;
  dCreditCardExpir: string;
}) {
  data.dCredtiCardExpir = data.dCreditCardExpir.replace(" ", "T");
  const json = JSON.parse(JSON.stringify(data));

  errors.value = "";
  const response = await api({
    url: `ledgers_autopay/?facilityId=${props.facilityId}&full_data=true`,
    method: "PUT",
    json,
  });
  if (response.status == 200) {
    getPaymentAccounts();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getCustomer();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : (customer.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_RouterLink, {
              to: {
          name: 'customer_detail_storedge',
          params: { id: customer.value.id, facilityId: __props.facilityId },
        }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Customer: " + _toDisplayString(customer.value.first_name) + " " + _toDisplayString(customer.value.last_name), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_3,
            (!_unref(api_settings).allow_autopay_changes)
              ? (_openBlock(), _createBlock(BaseAlert, {
                  key: 0,
                  variant: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Autopay is view-only here. Any changes to this customer's autopay enrollment or settings must be made directly in " + _toDisplayString(_unref(providerName)) + ". ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("tr", null, [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                (_unref(api_settings).autopay_day_and_date)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_8,
                      _hoisted_9
                    ], 64))
                  : _createCommentVNode("", true),
                (_unref(api_settings).allow_autopay_changes)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_10))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rentals.value, (rental) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: rental.id + 'ledger'
                }, [
                  _createElementVNode("td", null, "Unit " + _toDisplayString(rental.unit.name), 1),
                  _createElementVNode("td", null, _toDisplayString(rental.autopay_enabled ? "Enabled" : "Not enabled"), 1),
                  (
              rental.autopay_info && rental.autopay_info.account_or_card_number
            )
                    ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(rental.autopay_info.payment_type) + " " + _toDisplayString(rental.autopay_info.account_or_card_number), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_12, "-")),
                  (_unref(api_settings).autopay_day_and_date)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (rental.autopay_enabled)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("td", null, _toDisplayString(rental.autopay_info.day), 1),
                              _createElementVNode("td", null, _toDisplayString(rental.autopay_info.next_autopay_date), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_13,
                              _hoisted_14
                            ], 64))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(api_settings).allow_autopay_changes)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                        (_unref(api_settings).saved_payment_details)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (!rental.autopay_enabled)
                                ? (_openBlock(), _createBlock(_component_RouterLink, {
                                    key: 0,
                                    to: {
                  name: 'account_detail',
                  params: {
                    customerId: customer.value.id,
                    customerName:
                      customer.value.first_name + ' ' + customer.value.last_name,
                    accountId: rental.id,
                    facilityId: __props.facilityId,
                  },
                },
                                    class: "btn btn-outline-blue"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_16
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn btn-outline-blue",
                                    onClick: ($event: any) => (deactivateAutopay(rental.full_data))
                                  }, " Deactivate ", 8, _hoisted_17))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (paymentAccounts.value)
                                ? (_openBlock(), _createBlock(_component_RouterLink, {
                                    key: 0,
                                    to: {
                  name: 'account_detail',
                  params: {
                    customerId: customer.value.id,
                    customerName:
                      customer.value.first_name + ' ' + customer.value.last_name,
                    accountId: rental.id,
                    facilityId: __props.facilityId,
                  },
                },
                                    class: "btn btn-outline-blue"
                                  }, {
                                    default: _withCtx(() => [
                                      (!rental.autopay_enabled)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _hoisted_18
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _hoisted_19
                                          ], 64)),
                                      _hoisted_20
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})